import { useDispatch, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIFixedSaveBar from 'UIComponents/panel/UIFixedSaveBar';
import { trackSaveBarCancel } from '../../utils/usageTracker';
import { saveDealsUpdates } from '../../actions/DealsActions';
import { cancelDealsUpdates } from '../../actions/StagedDealsUpdatesActions';
import { getStagedDealsUpdates } from '../../selectors/stagedDealsUpdatesSelectors';
import { getAreAllPropertiesSaveable } from '../../selectors/dealValidationSelectors';
import { getIsDealStageView } from '../../selectors/forecastSelectors';
import { getShowSubmissionPanelFromDealTable } from '../../selectors/dealsSelectors';
import { getIsUngatedToManualSubmissionOverhaul } from '../../selectors/authSelectors';
import { stagedDealUpdateCount } from '../../utils/stagedDealsUpdatesUtils';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SaveBar = ({
  ownerId
}) => {
  const dispatch = useDispatch();
  const stagedDealsUpdates = useSelector(getStagedDealsUpdates);
  const stagedUpdatesCount = stagedDealUpdateCount(stagedDealsUpdates);
  const allStagedPropertyUpdatesSaveable = useSelector(getAreAllPropertiesSaveable);
  const isDealStageView = useSelector(getIsDealStageView);
  const isSubmissionPanelOpen = useSelector(getShowSubmissionPanelFromDealTable);
  const isUngatedToManualSubmissionOverhaul = useSelector(getIsUngatedToManualSubmissionOverhaul);
  const submissionPanelOverride = isUngatedToManualSubmissionOverhaul && isSubmissionPanelOpen;
  if (!Object.keys(stagedDealsUpdates).length) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIFixedSaveBar, {
    "data-test-id": "fdt-save-bar",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(UIButton, {
        disabled: !allStagedPropertyUpdatesSaveable || submissionPanelOverride
        // NOTE: We don't have a usage tracking event here because it is tracked
        // via trackInlineEditDealProperty within DealsActions
        ,
        onClick: () => {
          dispatch(saveDealsUpdates(ownerId, stagedUpdatesCount));
        },
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dealTable.saveBar.save"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        disabled: submissionPanelOverride,
        onClick: () => {
          dispatch(cancelDealsUpdates(ownerId)).catch(() => {
            // should be caught in fetchDealData
          });
          trackSaveBarCancel(isDealStageView);
        },
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dealTable.saveBar.cancel"
        })
      }), stagedUpdatesCount && /*#__PURE__*/_jsx(Flex, {
        marginInlineStart: "300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: submissionPanelOverride ? 'dealTable.saveBar.unsavedEditsWithOpenPanelMessage' : 'dealTable.saveBar.unsavedEditsMessage',
          options: {
            count: stagedUpdatesCount
          }
        })
      })]
    })
  });
};
export default SaveBar;